module.exports = __webpack_public_path__ + "img/slider_9.4e679a2b.jpg";